// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3636": "dbfc89bc969b","3650": "91d2f2f2d2b6","5015": "59cf926dd644","6040": "d33576355f09",}[chunkId] + ".css"
}